<template>
  <div class="mt-2 flex w-[352px]">
    <OfferForm
      :offered-symbol="offer"
      :order-type="orderType"
      :order="order"
      :loading="isLoadingUpdateInitialPublicOffer"
      :type="FORM_TYPES.edit"
      @submit="updatePublicInitialOffer"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDialog, useToast } from '@negar/core';
import { useLiveOrdersQuery } from '@core/order';
import {
  useUpdateInitialPublicOffer,
  FORM_TYPES,
  IPO_QUERY_KEYS,
} from '@core/ipo';
import { InitialPublicOfferItem } from '@libs/api-reference';
import { useQueryClient } from '@libs/use';

import { OfferForm } from '@/modules/ipo';

const props = defineProps<{
  isin: string;
  orderType: string;
  orderId: string;
  offer: InitialPublicOfferItem;
}>();

const { t } = useI18n();
const toast = useToast();
const { removeAll } = useDialog();

const queryClient = useQueryClient();

const { orders } = useLiveOrdersQuery();

const order = computed(() => {
  return orders.value.find((o) => o.orderId === props.orderId);
});

const {
  updatePublicInitialOffer,
  isPending: isLoadingUpdateInitialPublicOffer,
} = useUpdateInitialPublicOffer({
  onSuccess() {
    toast.neutral({
      message: t('ipo.editOrderMessage'),
      duration: 3000,
    });

    queryClient.invalidateQueries(IPO_QUERY_KEYS.ipo);

    removeAll();
  },
  onReject(error) {
    const message = error.response?.data[0].message;

    if (message) {
      toast.negative({
        message,
        duration: 3000,
      });
    }
  },
});
</script>
